import ko from 'knockout';
import _ from 'underscore';
import { CONTEXTUAL_DELIVERY_STATUS } from '@bingads-webui-campaign/recommendation-core';

export default class ViewModel {
  constructor({
    i18n,
  }) {
    this.i18n = i18n;
    this.adgroupDeliveryStatusTitle = ko.observable('');
    this.adgroupDeliveryStatus = ko.observable('');
    this.eligibleStatusIcon = ko.observable(false);
    this.showStatusIcon = ko.observable(false);
  }

  updateAttribute({
    adgroupDeliveryStatus,
  }) {
    const { i18n } = this;
    this.adgroupDeliveryStatusTitle(i18n.getString('AdGroup_Delivery_Status'));
    this.adgroupDeliveryStatus(_.contains(CONTEXTUAL_DELIVERY_STATUS, adgroupDeliveryStatus) ?
      i18n.getString(`Label_DeliveryStatus_${adgroupDeliveryStatus}`) :
      i18n.getString('Contextual_Response_Null'));

    if (this.adgroupDeliveryStatus() !== i18n.getString('Contextual_Response_Null')) {
      this.showStatusIcon(true);
    }
    if (this.adgroupDeliveryStatus() === i18n.getString('EntityStatus_Eligible')) {
      this.eligibleStatusIcon(true);
    }
  }
}
